import { BrowserRouter, Route, Routes } from "react-router-dom";
import FormPage from "../Pages/FormPage";
import ThankYou from "../Pages/DeferredThankYou";
import NotFound from "../Pages/NotFound";


const AllRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FormPage />} />
        <Route path="/thank-you" element={<ThankYou />} />

        {/* 404 fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AllRoutes;
